import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Preloader from "../components/Preloader";
import MagnetCursor from "../components/MagnetCursor";
import ScrollToTop from "../components/ScrollToTop";

const SECTORS_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_sectors";

function CaseStudy() {
  const [sectors, setSectors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.style.display = "none";
  }, []);

  useEffect(() => {
    fetch(`${SECTORS_API}?page=1&limit=50`)
      .then((r) => r.json())
      .then((json) => {
        if (Array.isArray(json?.data)) setSectors(json.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb Section */}
      <div
        className="breadcrumb-section breadcrumb-compact bg-img jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{ backgroundImage: "url('assets/img/bg-img/73.jpg')" }}
      >
        <div className="divider"></div>
        <div className="container">
          <div className="breadcrumb-content">
            <h2
              className="wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="700ms"
            >
              Sectors
            </h2>
            <ul
              className="list-unstyled wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="1000ms"
            >
              <li>
                <Link className="magnet-link" to="/">
                  Home
                </Link>
              </li>
              <li>Sectors</li>
            </ul>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      {/* Sectors Grid */}
      <section className="bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-7">
              <div className="section-heading text-center">
                <div className="sub-title justify-content-center">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Our Sectors
                </div>
                <h2>Areas We Serve</h2>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-secondary" role="status">
                <span className="visually-hidden">Loading&hellip;</span>
              </div>
            </div>
          ) : sectors.length === 0 ? (
            <div className="text-center py-5">
              <p>No sectors available yet.</p>
            </div>
          ) : (
            <div className="row g-4 mt-2">
              {sectors.map((s) => (
                <div key={s.id} className="col-12 col-sm-6 col-md-4">
                  <div
                    className="h-100 p-4 d-flex flex-column"
                    style={{ background: "#faf6f3", borderRadius: "12px" }}
                  >
                    <div className="h5 mb-3">{s.title}</div>
                    {s.description && (
                      <p
                        className="mb-3 flex-grow-1"
                        style={{ color: "#555", fontSize: "14px" }}
                        dangerouslySetInnerHTML={{
                          __html:
                            s.description.replace(/<[^>]+>/g, "").slice(0, 160) +
                            (s.description.replace(/<[^>]+>/g, "").length > 160 ? "…" : ""),
                        }}
                      />
                    )}
                    <Link
                      to={`/sectordetails?id=${s.id}`}
                      className="btn btn-sm btn-primary mt-auto"
                    >
                      <span>
                        Read More <i className="ti ti-arrow-up-right"></i>
                      </span>
                      <span>
                        Read More <i className="ti ti-arrow-up-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="divider"></div>
      </section>

      {/* Scroll To Top */}
      <ScrollToTop />
      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}

export default CaseStudy;
